import React from 'react';
import Icon from '../../../components/AppIcon';

const VarianceAnalysisTable = ({ varianceData }) => {
  const getVarianceColor = (type) => {
    if (type === 'positive') return 'text-success';
    if (type === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getVarianceIcon = (type) => {
    if (type === 'positive') return 'TrendingUp';
    if (type === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return typeof value === 'number' ? value?.toFixed(2) : value;
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Variance Analysis
          </h3>
        </div>
        <p className="caption text-xs md:text-sm text-muted-foreground mt-1">
          Period-over-period comparison of key compliance metrics
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left">
                <span className="caption text-xs font-medium text-foreground">Metric</span>
              </th>
              <th className="px-4 py-3 text-left hidden md:table-cell">
                <span className="caption text-xs font-medium text-foreground">Category</span>
              </th>
              <th className="px-4 py-3 text-right">
                <span className="caption text-xs font-medium text-foreground">Current</span>
              </th>
              <th className="px-4 py-3 text-right">
                <span className="caption text-xs font-medium text-foreground">Previous</span>
              </th>
              <th className="px-4 py-3 text-right">
                <span className="caption text-xs font-medium text-foreground">Variance</span>
              </th>
              <th className="px-4 py-3 text-left hidden lg:table-cell">
                <span className="caption text-xs font-medium text-foreground">Notes</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {varianceData?.map((item, index) => (
              <tr key={item?.id || index} className="border-b border-border hover:bg-muted/50 transition-smooth">
                <td className="px-4 py-3">
                  <p className="caption text-sm font-medium text-foreground">{item?.metricName}</p>
                  {item?.department && item?.department !== 'All' && (
                    <p className="caption text-xs text-muted-foreground">{item?.department}</p>
                  )}
                </td>
                <td className="px-4 py-3 hidden md:table-cell">
                  <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full capitalize">
                    {item?.metricCategory}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <p className="caption text-sm font-medium text-foreground">{formatValue(item?.currentValue)}</p>
                </td>
                <td className="px-4 py-3 text-right">
                  <p className="caption text-sm text-muted-foreground">{formatValue(item?.previousValue)}</p>
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-1">
                    <Icon 
                      name={getVarianceIcon(item?.varianceType)} 
                      size={14} 
                      color={getVarianceColor(item?.varianceType)?.replace('text-', 'var(--color-)')} 
                    />
                    <p className={`caption text-sm font-medium ${getVarianceColor(item?.varianceType)}`}>
                      {item?.variancePercentage > 0 ? '+' : ''}{item?.variancePercentage?.toFixed(2)}%
                    </p>
                  </div>
                </td>
                <td className="px-4 py-3 hidden lg:table-cell">
                  <p className="caption text-xs text-muted-foreground">{item?.analysisNotes || 'No notes'}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {(!varianceData || varianceData?.length === 0) && (
        <div className="p-8 text-center">
          <Icon name="TrendingUp" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3 opacity-50" />
          <p className="caption text-sm text-muted-foreground">No variance analysis data available</p>
        </div>
      )}
    </div>
  );
};

export default VarianceAnalysisTable;